import { memo } from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { Star16Filled } from '@fluentui/react-icons';
import { useStyles } from './CumulativeProgramPoint.styles';

interface Props {
  totalPointsEarned: number
  pointsLabel: string
  earnNextPointMessage: string
  customClassName?: string
}

const CumulativeProgramPoint: React.FC<Props> = (
  { totalPointsEarned,
    pointsLabel,
    earnNextPointMessage,
    customClassName,
  }) => {
  const styles = useStyles();

  return (
    <div className={mergeClasses('points-summary-container', styles.pointsSummaryContainer)}>
      <span className={mergeClasses(styles.totalPointsEarnedText, customClassName)}>
        {`${totalPointsEarned} ${pointsLabel}`}
      </span>
      {
        !!earnNextPointMessage && (
          <div className={styles.earnedNextPointContainer}>
            <Star16Filled className={styles.starIcon} />
            <span
              data-testid="earnedNextPointText"
              className={mergeClasses('earn-next-point-text', styles.earnedNextPointText, customClassName)}
            >
              {earnNextPointMessage}
            </span>
          </div>
        )
      }
    </div>
  );
};

export default memo(CumulativeProgramPoint);
